import axios from 'axios';

/**
 * add
 */
export const add = data => axios.$callAPI(() => axios.post('journals/', data));
/**
 * get list
 */
export const getJournalList = data => axios.$callAPI(() => axios.get('journals/search', { params: data }));

/**
 * get journalsInfo
 */
export const getJournalInfo = id => axios.$callAPI(() => axios.get('/journals/' + id));

/**
 * edit
 */
export const edit = (id, data) => axios.$callAPI(() => axios.put('journals/' + id, data));

/**
 * 删除
 */
export const del = id => axios.$callAPI(() => axios.delete('journals/' + id));
/**
 * 批量删除
 */
export const delAll = ids => axios.$callAPI(() => axios.delete('journals/', { data: ids }));
